import { MenuSection } from '@components/Sidebar/Menu/MenuSection';
import { routesPath } from '@router/routes';
import { prepareUrl } from '@utils/routerHelpers';

type SiteRoute = {
  title: string;
  name: 'subjects' | 'queries';
  path: string;
  icon: string;
};

export const siteRoutes: SiteRoute[] = [
  {
    title: 'Subjects',
    name: 'subjects',
    path: routesPath.subject,
    icon: 'subjects',
  },
  {
    title: 'Queries',
    name: 'queries',
    path: routesPath.subjectQueries,
    icon: 'puzzle',
  },
];

export const renderSiteMenuSections = (
  clinicalTrialId: string | undefined,
  sidebarCollapsed: boolean
) =>
  siteRoutes.map((item, i) => {
    const path =
      item.name === 'queries'
        ? prepareUrl(routesPath.subjectQueries, [clinicalTrialId as string])
        : prepareUrl(routesPath.subject, [clinicalTrialId as string]);

    return (
      <MenuSection
        item={{ ...item, path }}
        key={item.name}
        menuIndex={i}
        sideBarCollapsed={sidebarCollapsed}
      />
    );
  });
